module.exports = __webpack_public_path__ + "static/media/ff_logo.814e5cc4.jpg";